const WORKSPACE_ROLE_CHANGE_TYPES = new Set([
  'workspace_member_joined',
  'workspace_member_left',
  'workspace_member_revoked',
  'workspace_member_role_changed',
]);

export function workspacePermissionEventMayChangeRole(changeType: string) {
  return WORKSPACE_ROLE_CHANGE_TYPES.has(changeType);
}
